import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from './Header'; 
import './Feed.css';
import { setInternalNavigation, isInternalNavigation } from '../utils/cookies';

const Feed = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingProgress, setLoadingProgress] = useState(0);
  const [lightboxImage, setLightboxImage] = useState(null); 

  useEffect(() => {
    const hasSeenFeedPage = sessionStorage.getItem('hasSeenFeedPage');
    
    if (hasSeenFeedPage === 'true') {
      setLoading(false);
      setLoadingProgress(100);
      return;
    }

    let timer;
    let progressTimer;
    
    if (loading) {
      progressTimer = setInterval(() => {
        setLoadingProgress(prev => {
          if (prev >= 100) {
            clearInterval(progressTimer);
            return 100;
          }
          return prev + 1;
        });
      }, 30); 
      
      timer = setTimeout(() => {
        setLoading(false);
        sessionStorage.setItem('hasSeenFeedPage', 'true'); 
        setInternalNavigation(); 
      }, 3000); 
    }
    
    return () => {
      clearTimeout(timer);
      clearInterval(progressTimer);
    };
  }, [loading]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    document.body.style.overflow = isMenuOpen ? 'auto' : 'hidden';
  };
  
  const openLightbox = (imageSrc) => {
    setLightboxImage(imageSrc);
    document.body.style.overflow = 'hidden'; 
  };

  const closeLightbox = () => {
    setLightboxImage(null);
    document.body.style.overflow = 'auto'; 
  };

  const galleryItems = [
    {
      id: 'galleryItem1',
      title: 'Blank Street Matcha!',
      image: '/media/blankstreet.JPG',
      category: 'New York, NY',
      link: '#',
      size: 'medium' 
    },
    {
      id: 'galleryItem2',
      title: '',
      image: '/media/brown.JPG',
      category: 'switzerland',
      link: '#',
      size: 'medium' 
    },
    {
      id: 'galleryItem3',
      title: 'mom!',
      image: '/media/mom.jpg',
      category: '',
      link: '#',
      size: 'small' 
    },
    {
      id: 'galleryItem4',
      title: '',
      image: '/media/grass.jpg',
      category: '',
      link: '#',
      size: 'large' 
    },
    {
      id: 'galleryItem5',
      title: '',
      image: '/media/water.jpg',
      category: '',
      link: '#',
      size: 'medium' 
    },
    {
      id: 'galleryItem6',
      title: '',
      image: '/media/walk.jpg',
      category: '',
      link: '#',
      size: 'medium' 
    },
    {
      id: 'galleryItem7',
      title: '',
      image: '/media/taiwan.jpg',
      category: 'taiwan',
      link: '#',
      size: 'large' 
    },
    {
      id: 'galleryItem8',
      title: 'SAS!',
      image: '/media/sas.jpg',
      category: '',
      link: '#',
      size: 'small' 
    },
    {
      id: 'galleryItem9',
      title: 'sonny angel',
      image: '/media/sonny.jpg',
      category: '',
      link: '#',
      size: 'medium' 
    },
    {
      id: 'galleryItem10',
      title: '',
      image: '/media/louvre.jpg',
      category: '',
      link: '#',
      size: 'large' 
    },
    {
      id: 'galleryItem11',
      title: '',
      image: '/media/idk.jpg',
      category: 'paris',
      link: '#',
      size: 'small' 
    },
    {
      id: 'galleryItem12',
      title: '',
      image: '/media/bean.jpg',
      category: '',
      link: '#',
      size: 'medium' 
    },
    {
      id: 'galleryItem13',
      title: 'matcha again',
      image: '/media/matcha.jpg',
      category: '',
      link: '#',
      size: 'large' 
    },
    {
      id: 'galleryItem14',
      title: '',
      image: '/media/waterfall.jpg',
      category: 'Upstate NY',
      link: '#',
      size: 'medium' 
    },
    {
      id: 'galleryItem15',
      title: 'SAS Interns Final Presentation Day!',
      image: '/media/sasPres.jpg',
      category: 'SAS Headquarters - Cary, NC',
      link: '#',
      size: 'medium' 
    },
    {
      id: 'galleryItem16',
      title: '',
      image: '/media/cat.jpg',
      category: '',
      link: '#',
      size: 'large' 
    },
    {
      id: 'galleryItem17',
      title: 'bodega cat',
      image: '/media/bodega.jpg',
      category: '',
      link: '#',
      size: 'large' 
    },
    {
      id: 'galleryItem18',
      title: '',
      image: '/media/peace.JPG',
      category: 'OBX',
      link: '#',
      size: 'medium' 
    },
    {
      id: 'galleryItem19',
      title: '',
      image: '/media/nyc.jpg',
      category: '',
      link: '#',
      size: 'small' 
    }, 
    {
      id: 'galleryItem20',
      title: '',
      image: '/media/selfie.jpg',
      category: 'Chapel Hill, NC',
      link: '#',
      size: 'medium' 
    }
  ];

  return (
    <div className="feed-container">
      {loading ? (
        <div className="video-loading-screen">
          <video 
            autoPlay 
            muted 
            className="loading-video"
            onEnded={() => setLoading(false)}
          >
            <source src="/videos/nyc-skyline.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div className="loading-overlay">
            <div className="loading-text">FEED.app</div>
          </div>
          <div className="loading-text">LOADING NYC...</div>
          <div className="loading-bar-container">
            <div 
              className="loading-bar" 
              style={{ width: `${loadingProgress}%` }}
            ></div>
          </div>
        </div>
      ) : (
        <>
          <Header isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} />

          <div className={`menu ${isMenuOpen ? 'open' : ''}`}>
            <Link to="/" className="menu-item terminal-style" onClick={() => setInternalNavigation()}>$ cd /HOME</Link>
            <Link to="/feed" className="menu-item terminal-style" onClick={() => setInternalNavigation()}>$ open FEED.app</Link>
            <Link to="/about" className="menu-item terminal-style" onClick={() => setInternalNavigation()}>$ man ABOUT</Link>
          </div>

          <div className="feed-masonry-grid">
            {galleryItems.map(galleryItem => (
              <div 
                key={galleryItem.id} 
                className={`feed-item feed-item-${galleryItem.size}`}
              >
                <div className="feed-item-image-container" onClick={() => openLightbox(galleryItem.image)} style={{cursor: 'pointer'}}>
                  {galleryItem.category && (
                    <div className={`feed-item-category ${galleryItem.category.toLowerCase().replace(' ', '-')}`}>
                      {galleryItem.category}
                    </div>
                  )}
                  <img 
                    src={galleryItem.image} 
                    alt={galleryItem.title} 
                    className="feed-item-image" 
                  />
                </div>
                <h3 className="feed-item-title">{galleryItem.title}</h3> 
              </div>
            ))}
          </div>

          {lightboxImage && (
            <div className="simple-lightbox-overlay" onClick={closeLightbox}>
              <div className="simple-lightbox-content" onClick={(e) => e.stopPropagation()}>
                <button className="close-lightbox-button" onClick={closeLightbox}>&times;</button>
                <img src={lightboxImage} alt="Enlarged view" className="simple-lightbox-image" />
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Feed;
